import React from 'react'

// styles
import './SplitDayScopeInput.css'

// components
import InputField from '../../InputField/InputField.component'

// mui
import { Typography, Container, Grid } from '@mui/material'

export default function SplitDayScopeInput({ prefix, id, value, handleChange, errors = {} }) {

    return (<Container disableGutters sx={{ marginBottom: 4}}>
        <Typography variant="h5" sx={{ marginBottom: 2}}>{id === 0 ? 'A - Scope' : id === 1 ? 'B - Scope' : 'C - Scope'}</Typography>
        <InputField 
            type='textarea'
            id={`${prefix}.scope`}
            onChange={handleChange}
            value={value}
            isValid={errors['scope']}
        />
    </Container>)
}